import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";
import RequestUrlDoubleId from "types/RequestUrlDoubleId";
import { menusUrl } from "../Menus/config";

const baseUrl = `/items`;

const requests = {
    menuItemsFetch: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`${menusUrl}/${url.id}${baseUrl}`, config),
    menuItemGet: (config: AxiosRequestConfig, url: RequestUrlDoubleId) =>
        api.get(`${menusUrl}/${url.prevId}${baseUrl}/${url.id}`, config),
    menuItemUpdate: (
        data: object,
        config: AxiosRequestConfig,
        url: RequestUrlDoubleId
    ) => api.put(`${menusUrl}/${url.prevId}${baseUrl}/${url.id}`, data, config),
    menuItemDelete: (config: AxiosRequestConfig, url: RequestUrlDoubleId) =>
        api.delete(`${menusUrl}/${url.prevId}${baseUrl}/${url.id}`, config),
    menuItemCreate: (
        data: object,
        config: AxiosRequestConfig,
        url: RequestUrlId
    ) => api.post(`${menusUrl}/${url.id}${baseUrl}`, data, config),
    menuItemsCostAvg: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`${menusUrl}/${url.id}${baseUrl}/average-cost`, config),
};

export default requests;
